const nav = document.getElementById( 'topnav' );

if ( nav ) {
	const onScroll = () => {
		if ( window.scrollY > 40 ) {
			nav.classList.add( 'scrolled' );
		} else {
			nav.classList.remove( 'scrolled' );
		}
	};
	window.addEventListener( 'scroll', onScroll, { passive: true } );
	onScroll();
}

const navToggle   = document.getElementById( 'nav-toggle' );
const mobileMenu  = document.getElementById( 'mobile-menu' );

if ( navToggle && mobileMenu ) {
	const setMenu = ( open ) => {
		navToggle.setAttribute( 'aria-expanded', open ? 'true' : 'false' );
		navToggle.setAttribute( 'aria-label', open ? 'Close menu' : 'Open menu' );
		mobileMenu.classList.toggle( 'open', open );
		mobileMenu.setAttribute( 'aria-hidden', open ? 'false' : 'true' );
		document.body.style.overflow = open ? 'hidden' : '';
	};

	navToggle.addEventListener( 'click', () => {
		const isOpen = navToggle.getAttribute( 'aria-expanded' ) === 'true';
		setMenu( !isOpen );
	} );

	mobileMenu.querySelectorAll( 'a' ).forEach( ( a ) => {
		a.addEventListener( 'click', () => setMenu( false ) );
	} );

	window.addEventListener( 'resize', () => {
		if ( window.innerWidth > 860 && navToggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			setMenu( false );
		}
	} );

	window.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && navToggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			setMenu( false );
		}
	} );
}

const io = new IntersectionObserver(
	( entries ) => {
		entries.forEach( ( e ) => {
			if ( e.isIntersecting ) {
				e.target.classList.add( 'in' );
				io.unobserve( e.target );
			}
		} );
	},
	{ threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
);
document.querySelectorAll( '.observe' ).forEach( ( el ) => io.observe( el ) );

document.querySelectorAll( 'a[href^="#"]' ).forEach( ( a ) => {
	a.addEventListener( 'click', ( e ) => {
		const id = a.getAttribute( 'href' );
		if ( id.length < 2 ) {
			return;
		}
		const target = document.querySelector( id );
		if ( !target ) {
			return;
		}
		e.preventDefault();
		const top = target.getBoundingClientRect().top + window.scrollY;
		window.scrollTo( { top, behavior: 'smooth' } );
	} );
} );
